'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kn_IN = require('../locale/kn_IN');

var _kn_IN2 = _interopRequireDefault(_kn_IN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _kn_IN2['default'];